import LeadListTable from "components/pageSection/LeadList/LeadListTable";
import React, { useEffect, useLayoutEffect, useState } from "react";
import useLeads from "../../hooks/leads.hook";
import { Wrapper } from "./LeadList.styles";
import { Input, Row, Col, Loading, Drawer, Empty, Checkbox } from "components/common";
import { Calendar } from "antd";
import LeadListCard from "components/pageSection/LeadList/LeadListCard";
import { callGetApi, callGetApiWithAuth, callPostApiWithAuth } from "utils/api";
import { useHistory, useLocation } from "react-router";
import { getUserPermissions } from "utils/text";
import moment from "moment/moment.js";
import { CheckOutlined } from "@ant-design/icons";
import filter from "../../assets/images/filter.png";
import addCustomer from "assets/images/add-customer.png";
import { FaUserPlus, FaSearch } from "react-icons/fa";
import { LuFilterX } from "react-icons/lu";
import { MdOutlineFilterList, MdKeyboardArrowDown, MdKeyboardArrowUp, MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const LeadList = () => {
    const history = useHistory();
    const location = useLocation();
    const leadsHook = useLeads();
    const [sortBy, setSortBy] = useState({ name: '', dir: -1 });
    const [cards, setCards] = useState(false);
    const [leads, setLeads] = useState([]);
    const [pagination, setPagination] = useState({});
    const [status, setStatus] = useState([]);
    const [users, setUsers] = useState([]);

    //filters

    const [isFilter, setIsFilter] = useState(false);
    const [searchFilter, setSearchFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState([]);
    const [userFilter, setUserFilter] = useState([]);
    const [appointmentFilter, setAppointmentFilter] = useState('All');
    const [createdFilter, setCreatedFilter] = useState('All');
    const [btnFilter, setBtnFilter] = useState('');
    const [dateFilter, setDateFilter] = useState(moment());

    const [isLoading, setIsLoading] = useState(false);
    const [isSortLoading, setIsSortLoading] = useState(true);
    const [isShowOption, setIsShowOption] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const [weekDates, setWeekDates] = useState([]);
    const [weekDays, setWeekDays] = useState([]);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const showDefaultDrawer = () => {
        setIsOpen(true);
    };
    const setParams = (name, value, resetParams = false) => {
        let searchParams;
        if (location.search && !resetParams) {
            searchParams = new URLSearchParams(location.search)
        } else {
            let p = getParams();
            if (resetParams) {
                delete p?.appointment
                delete p?.btnFilter
                delete p?.created
                delete p?.date
                delete p?.sort
                searchParams = new URLSearchParams(p);
            } else {
                searchParams = new URLSearchParams()
            }
        }
        if (resetParams) {
            resetFilters();
        }
        searchParams.set('offset', 0);
        searchParams.set('limit', 10);
        searchParams.set(name, value);
        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        })
    }
    const getParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const entries = Object.fromEntries(urlParams);
        if (entries.status) {
            entries.status = entries.status.split(',');
        }
        if (entries.user) {
            entries.user = entries.user.split(',');
        }
        if (entries.sort) {
            let s = entries.sort.split(',');
            entries.sort = { [s[0]]: s[1] };
        }
        return entries;
    }
    const clearFilters = () => {
        setIsFilter(false);
        setIsSortLoading(true);
        setSearchFilter('')
        setStatusFilter([])
        setUserFilter([])
        setAppointmentFilter('All')
        setCreatedFilter('All')
        setBtnFilter('')
        setDateFilter(moment())
        const hash = {
            offset: 0,
            limit: 10
        }
        let searchParams = new URLSearchParams(hash);
        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        })
        getLeadApi();
    }
    const resetFilters = () => {
        setIsSortLoading(true);
        setAppointmentFilter('All')
        setCreatedFilter('All')
        setBtnFilter('')
        setDateFilter(moment())
    }
    const updateFiltersFromParams = () => {
        let params = getParams();
        if (params.status) {
            setStatusFilter(params.status)
        }
        if (params.user) {
            setUserFilter(params.user)
        }
        if (params.appointment) {
            setAppointmentFilter(params.appointment)
        }
        if (params.created) {
            setCreatedFilter(params.created)
        }
        if (params.btnFilter) {
            setBtnFilter(params.btnFilter)
        }
        if (params.date) {
            setDateFilter(moment(params.date))
        }
    }
    const handleChangeFilter = (e, name) => {
        setIsFilter(true);
        if (name === 'q') {
            setSearchFilter(e.target.value);
            setParams(name, e.target.value, true);
        }
        if (name === 'status') {
            setStatusFilter(e);
            setParams(name, e, true);
        }
        if (name === 'user') {
            setUserFilter(e);
            setParams(name, e, true);
        }
        if (name === 'appointment') {
            setAppointmentFilter(e);
            setParams(name, e);
        }
        if (name === 'created') {
            setCreatedFilter(e);
            setParams(name, e);
        }
        if (name === 'btnFilter') {
            if (e === btnFilter) {
                setBtnFilter('')
                setParams(name, '');
            } else {
                setBtnFilter(e)
                setParams(name, e);
            }
        }
        if (name === 'date') {
            setParams(name, moment(e).format("YYYY-MM-DD"));
        }
        setIsSortLoading(true);
        getLeadApi();
    };
    const getListStatusList = (id) => {
        if (!statusFilter && !statusFilter?.length) {
            return [id]
        } else {
            if (statusFilter?.includes(id)) {
                let filter = statusFilter.filter((e) => e !== id);
                return filter;
            } else {
                return [...statusFilter, id];
            }
        }
    }
    const getListUserList = (id) => {
        if (!userFilter && !userFilter?.length) {
            return [id]
        } else {
            if (userFilter?.includes(id)) {
                let filter = userFilter.filter((e) => e !== id);
                return filter;
            } else {
                return [...userFilter, id];
            }
        }
    }
    const updatePagination = (current, pageSize) => {
        if (!cards) {
            setIsSortLoading(true);
        }
        let searchParams = new URLSearchParams(window.location.search);
        if (!pageSize) {
            searchParams.set('offset', current)
        } else {
            searchParams.set('offset', current)
            searchParams.set('limit', pageSize)
        }
        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        })
        getLeadApi();
    }
    const sortHandleChange = (name) => {
        setIsSortLoading(true);
        let searchParams = new URLSearchParams(location.search);
        if (sortBy.name === name) {
            searchParams.set('sort', [name, sortBy.dir === 1 ? -1 : 1]);
            setSortBy({ name, dir: sortBy.dir === 1 ? -1 : 1 });
        } else {
            searchParams.set('sort', [name, -1]);
            setSortBy({ name, dir: -1 });
        }
        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        })
        setIsOpen(false);
        getLeadApi()
    }
    const onDateFilterChanged = (date) => {
        setDateFilter(date)
        handleChangeFilter(date, 'date')
    };
    // All Apis
    const getLeadApi = () => {
        setIsLoading(true);
        const params = getParams();
        callPostApiWithAuth("/leads/get", params, (data) => {
            setLeads(data.hits);
            setPagination(data.page);
            setIsLoading(false);
        }, (err) => {
            setIsLoading(false);
        });
    }
    const getStatusApi = () => {
        callGetApi("/appointment", (data) => {
            let statusesData = data.map((e) => ({ id: e._id, name: e.name }));
            setStatus(statusesData);
        }, (err) => { console.log(err) });
    }
    const getUsersApi = () => {
        callGetApi("/user", (data) => {
            let usersData = data.map((e) => ({ id: e._id, name: e.username }));
            setUsers(usersData);
        }, (err) => { console.log(err) });
    }
    const getProjectsReconcilation = () => {
        callGetApiWithAuth("/projects/all/accounts",
            () => { }, (err) => {
                console.log(err);
            }
        );
    };

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth < 900) {
                setCards(true);
            } else {
                return setCards(false);
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);
    useEffect(() => {
        const weekDates = leadsHook.getWeekAndDates();
        setWeekDates(weekDates.dates)
        setWeekDays(weekDates.days)

        //updatefilters
        updateFiltersFromParams();

        //call Apis
        getLeadApi();
        getStatusApi();
        getUsersApi();
        getProjectsReconcilation();
    }, [])

    return (
        <Wrapper isSmall={cards}>

            <Row gutter={[15, 15]} className="top-bar-row">
                <Col xs={24} sm={cards ? 24 : 22} lg={22} xl={22} xxl={22}>
                    <div className="search-container">
                        <Input placeholder="Search..." value={searchFilter} onChange={(e) => handleChangeFilter(e, 'q')} className="search-box" />
                        <FaSearch size={cards ? 18 : 20} className="icon" />
                    </div>
                </Col>
                {getUserPermissions("add-lead-action") && (
                    <>
                        {cards ? (
                            <Col xs={24} sm={24} lg={4} xl={4} xxl={4}>
                                <div className="sm-add-users-container">
                                    <div className="sm-add-users-title">Add Customers</div>
                                    <div className="sm-add-users-hr"></div>
                                    <img src={addCustomer} alt="add customer" className="sm-add-users-button" onClick={() => { history.push("/lead-form"); }} />
                                </div>
                            </Col>
                        ) : (
                            <Col xs={24} sm={cards ? 24 : 2} lg={2} xl={2} xxl={2}>
                                <div className="add-desktop-button">
                                    <FaUserPlus size={40} onClick={() => { history.push("/lead-form"); }} cursor="pointer" />
                                </div>
                            </Col>
                        )}
                    </>
                )}
            </Row>

            <div className="filter-Container">
                <div className="filter-colapeser">
                    <div className="title">
                        <MdOutlineFilterList color="white" size={cards ? 24 : 30} />
                        <span>Filter Options</span>
                    </div>
                    <div className="filter-icon">
                        {!isShowOption && (<MdKeyboardArrowDown color="white" size={cards ? 26 : 30} cursor="pointer" onClick={() => setIsShowOption(true)} />)}
                        {isShowOption && (<MdKeyboardArrowUp color="white" size={cards ? 26 : 30} cursor="pointer" onClick={() => setIsShowOption(false)} />)}
                    </div>
                </div>
                {isShowOption && (
                    <div className="filter-content">

                        <div className="clear-button-container">
                            <button className="clear-filter-btn" type="button" onClick={clearFilters}>
                                <span>Clear Filter</span>
                                <LuFilterX color="white" size={22} />
                            </button>
                        </div>

                        <Row gutter={[cards ? 15 : 30, cards ? 15 : 30]} className="filter-content-container">
                            <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                                <div className="fiter-box">
                                    <div className="title">
                                        <div className="text">Select Status</div>
                                        <div className="hr-line"></div>
                                    </div>
                                    <div className="content">
                                        {status?.map((data, key) => (
                                            <div className="options">
                                                <div className="option-name">
                                                    {data.name}
                                                </div>
                                                <div className="option-checkbox">
                                                    <Checkbox checked={statusFilter.includes(data?.id)} onChange={(e) => handleChangeFilter(getListStatusList(data?.id), 'status')} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                                <div className="fiter-box">
                                    <div className="title">
                                        <div className="text">Select Rep</div>
                                        <div className="hr-line"></div>
                                    </div>
                                    <div className="content">
                                        {users?.map((data, key) => (
                                            <div className="options">
                                                <div className="option-name">
                                                    {data.name}
                                                </div>
                                                <div className="option-checkbox">
                                                    <Checkbox checked={userFilter.includes(data?.id)} onChange={(e) => handleChangeFilter(getListUserList(data?.id), 'user')} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                                <div className="card-box">
                                    <div className="fiter-box">
                                        <div className="title-advance">
                                            <div className="text">Appointment</div>
                                            <div className="hr-line-advance">
                                            </div>
                                        </div>
                                        <div className="content-advance">
                                            <div className="sync-filter">
                                                {[
                                                    { name: "All", value: "All" },
                                                    { name: "Today", value: "Today" },
                                                    { name: "This Week", value: "Week" },
                                                ].map((e) => (
                                                    <div className={appointmentFilter === e?.value ? "sync-filter-option-active" : "sync-filter-option"} onClick={() => handleChangeFilter(e.value, 'appointment')}>{e.name}</div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fiter-box mag-t">
                                        <div className="title-advance">
                                            <div className="text">Created</div>
                                            <div className="hr-line-advance">
                                            </div>
                                        </div>
                                        <div className="content-advance">
                                            <div className="sync-filter">
                                                {[
                                                    { name: "All", value: "All" },
                                                    { name: "Day", value: "Day" },
                                                    { name: "Week", value: "Week" },
                                                    { name: "Month", value: "Month" },
                                                    { name: "Quarter", value: "Quarter" },
                                                ].map((e) => (
                                                    <div className={createdFilter === e?.value ? "sync-filter-option-active" : "sync-filter-option"} onClick={() => handleChangeFilter(e.value, 'created')}>{e.name}</div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fiter-box mag-t">
                                        <div className="title-advance">
                                            <div className="text">Type</div>
                                            <div className="hr-line-advance">
                                            </div>
                                        </div>
                                        <div className="content-advance">
                                            <div className="sync-filter">
                                                {[
                                                    { name: "AC", value: "AC" },
                                                    { name: "CON", value: "CON" },
                                                    { name: "SS", value: "SS" },
                                                    { name: "Install", value: "Install" },
                                                    { name: "PTO", value: "PTO" },
                                                    { name: "Cancelled", value: "Cancelled" },
                                                ].map((e) => (
                                                    <div className={btnFilter === e?.value ? "sync-filter-option-active" : "sync-filter-option"} onClick={() => handleChangeFilter(e.value, 'btnFilter')}>{e.name}</div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                                <div className="card-box">
                                    <div className="fiter-box">
                                        <div className="title-advance">
                                            <div className="text">Created After</div>
                                            <div className="hr-line-advance">
                                            </div>
                                        </div>
                                        <div className="content-advance">
                                            <div className="date-selected">
                                                Selected Date: {dateFilter.format("DD/MM/YYYY")}
                                            </div>
                                            <Calendar value={dateFilter} headerRender={({ value, type, onChange, onTypeChange }) => {
                                                const month = value.month();
                                                const year = value.year();
                                                return (
                                                    <div className="calender-options">
                                                        <MdKeyboardArrowLeft size={cards ? 26 : 30} cursor="pointer" onClick={() => {
                                                            const now = month - 1 < 0 ? value.clone().month(11).year(year - 1) : value.clone().month(month - 1);
                                                            onChange(now);
                                                        }} />
                                                        <div className="month">{months[month]} {year}</div>
                                                        <MdKeyboardArrowRight size={cards ? 26 : 30} cursor="pointer" onClick={() => {
                                                            const now = month + 1 > 11 ? value.clone().month(0).year(year + 1) : value.clone().month(month + 1);
                                                            onChange(now);
                                                        }} />
                                                    </div>
                                                )
                                            }} fullscreen={false} onSelect={onDateFilterChanged} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
            {cards && (
                <div className="small-screen-sorter">
                    <img src={filter} onClick={() => { setIsOpen(true); }} alt="Sorter" />
                </div>
            )}
            {cards ? (isLoading && isSortLoading ? (
                <Loading />
            ) : (
                <div>
                    {!leads.length && isSortLoading ? (
                        <div className="full-width-container-space">
                            <Empty />
                        </div>
                    ) : (
                        <LeadListCard
                            data={leads}
                            isLoading={isLoading}
                            status={status}
                            users={users}
                            setIsSortLoading={setIsSortLoading}
                            showDefaultDrawer={showDefaultDrawer}
                            pagination={pagination}
                            updatePagination={updatePagination}
                        />
                    )}
                </div>
            )) : (
                <LeadListTable
                    data={leads}
                    isLoading={isLoading}
                    status={status}
                    users={users}
                    updatePagination={updatePagination}
                    pagination={pagination}
                    sortHandleChange={sortHandleChange}
                />
            )}

            <Drawer
                title="Sort Leads By."
                placement="bottom"
                className="bottom-drawer"
                onClose={() => {
                    setIsOpen(false);
                }}
                visible={isOpen}
            >
                <div style={{ padding: "15px" }}>
                    <Row>
                        <Col span={24}>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => sortHandleChange('firstName')}
                                        style={{
                                            fontWeight: sortBy.name == "firstName" ? "bold" : "normal",
                                        }}
                                    >
                                        Name
                                        {sortBy.name == "firstName" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => sortHandleChange('status')}
                                        style={{
                                            fontWeight: sortBy.name == "status" ? "bold" : "normal",
                                        }}
                                    >
                                        Status
                                        {sortBy == "status" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => sortHandleChange('street')}
                                        style={{
                                            fontWeight: sortBy.name == "street" ? "bold" : "normal",
                                        }}
                                    >
                                        Address
                                        {sortBy.name == "street" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => sortHandleChange('setter')}
                                        style={{
                                            fontWeight: sortBy.name == "setter" ? "bold" : "normal",
                                        }}
                                    >
                                        Created By
                                        {sortBy.name == "setter" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => sortHandleChange('dateCreated')}
                                        style={{
                                            fontWeight: sortBy.name === "dateCreated" ? "bold" : "normal",
                                        }}
                                    >
                                        Date Created
                                        {sortBy.name == "dateCreated" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => sortHandleChange('appointmentTime')}
                                        style={{
                                            fontWeight: sortBy.name == "appointmentTime" ? "bold" : "normal",
                                        }}
                                    >
                                        Appointment
                                        {sortBy.name == "appointmentTime" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>

            </Drawer>

        </Wrapper>
    )
};

export default LeadList;
